<template>
    <div class="pa-5 compact-form" v-if="activeCompany">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Email" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeCompany.contact_email"
                    @input="updateField($event, 'contact_email')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Phone" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeCompany.contact_phone"
                    @input="updateField($event, 'contact_phone')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeCompany.contact_address"
                    @input="updateField($event, 'contact_address')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "../../../store";

export default {
    name: "contact-info-edit-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState(["activeCompany"])
    },
    methods: {
        updateField(value, field) {
            Store.commit("updateActiveCompanyProperty", { prop: field, value: value });
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
